import { API2_HOST } from '../../helpers/urlHelper';
import {
  baseGet,
  basePut
} from 'services/base-services/baseService';
const baseURL = `${API2_HOST}/suppliers`;

const getSupplierDetails = async id => {
  const res = await baseGet(`${baseURL}`, id);
  return res;
};

const updateSupplier = async (id, request) => {
  const res = await basePut(`${baseURL}`, request, id);
  return res;
};

export { getSupplierDetails, updateSupplier };
